import { useGetGroups } from '@vindr/services/actions/group.action';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../../ui/Table';
import Filter from './Filter';
import useGroupSearchColumns from './useGroupSearchColumns';

const GroupSearch = ({ selectedAccounts, onSave, onCancel, initFilters }) => {
  const { t } = useTranslation('Vindoc');
  const columns = useGroupSearchColumns({});
  const [params, setParams] = useState(initFilters);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { data, isFetching, isLoading, refetch } = useGetGroups({
    limit: 100,
    offset: 0,
    active: true,
    ...params,
  });
  const accountList = data?.data;

  const [isRefetch, setIsRefetch] = useState(false);
  useEffect(() => {
    if (!isFetching) {
      // After fetching, set isRefetch to false;
      setIsRefetch(false);
    }
  }, [isFetching]);

  const forceSearch = (params) => {
    setParams(params);
    // Set refetch to true only when force search
    setIsRefetch(true);
    refetch?.();
  };

  useEffect(() => {
    setSelectedRowKeys(selectedAccounts.map((it) => it?.id));
  }, [selectedAccounts]);

  return (
    <div className="flex flex-col">
      <Filter
        initFilters={initFilters}
        onChange={(p) => {
          setParams(p);
        }}
        forceSearch={forceSearch}
      />
      <Table
        rowSelection={{
          selectedRowKeys,
          onChange: (keys) => {
            setSelectedRowKeys(keys);
          },
        }}
        columns={columns}
        loading={isLoading || isRefetch}
        dataSource={accountList || []}
        scroll={{ y: 500 }}
        rowKey="id"
        pagination={null}
      />
      <div className="footer mt-3 flex justify-end">
        <Button onClick={onCancel}>{t('Cancel')}</Button>
        <Button
          type="primary"
          onClick={() => onSave(accountList.filter((it) => selectedRowKeys.includes(it.id)))}
          className="ml-2"
        >
          {t('Save')}
        </Button>
      </div>
    </div>
  );
};

export default GroupSearch;
